module.exports = __webpack_public_path__ + "img/notes.21076b12.png";